import { useMemo } from "react";

const GOOGLE_FAVICON_ENDPOINT = "https://www.google.com/s2/favicons";

function normalizeDomain(domain?: string | null) {
  if (!domain) return null;
  return domain
    .trim()
    .replace(/^[a-z]+:\/\//i, "")
    .replace(/\/.*$/, "");
}

export function useFaviconUrl(domain?: string | null, size = 96) {
  return useMemo(() => {
    const normalized = normalizeDomain(domain);
    if (!normalized) return null;

    try {
      const encoded = encodeURIComponent(normalized);
      return `${GOOGLE_FAVICON_ENDPOINT}?sz=${size}&domain_url=${encoded}`;
    } catch {
      return null;
    }
  }, [domain, size]);
}
